import { addEvent, removeEvent, triggerEvent } from '../utils/events';
import { addClasses, removeClasses } from '../utils/html';

export class DismissableSidebarPanel {
  constructor(config) {
    this.dismissableSidebarPanels = config.dismissableSidebarPanel;
    this.sidePanel = config.dismissableSidebarPanel.firstElementChild.firstElementChild;

    if (!this.isEverythingOk()) {
      return;
    }

    this.closeClickArea = config.dismissableSidebarPanel.querySelector(config.closeSelector);
    this.openClickArea = document.querySelector(config.openSelector);
    this.remoteOpenClickArea = config.dismissableSidebarPanel.querySelector(config.remoteOpenClickArea);
    this.applyDismissableSidebarPanelClickArea = config.dismissableSidebarPanel
      .querySelector(config.applyDismissableSidebarPanelSelector);
    this.sidebarForm = config.dismissableSidebarPanel.querySelector('form');

    this.sidePanel.style.width = config.width;

    this.isOpen = false;

    this.init();
  }

  /**
   * Assigns events to the close button
   * and the dismissable sidebar panel action button (Apply)
   * @return undefined
   */
  init() {
    if (this.closeClickArea) {
      addEvent(this.closeClickArea, 'click', this.close.bind(this));
    }
    if (this.applyDismissableSidebarPanelClickArea) {
      addEvent(this.applyDismissableClickArea, 'click', this.apply.bind(this));
    }
    if (this.sidebarForm) {
      addEvent(this.sidebarForm, 'keyup', this.enableAction.bind(this));
      addEvent(this.sidebarForm, 'change', this.enableAction.bind(this));
    }
    if (this.openClickArea || this.remoteOpenClickArea) {
      addEvent(this.openClickArea, 'click', this.open.bind(this));
      addEvent(this.remoteOpenClickArea, 'click', this.open.bind(this));
    }
  }

  /**
   * Removes the disabled attribute
   * from the sidebar action
   * @return undefined
   */
  enableAction() {
    if (this.applyDismissableClickArea) {
      this.applyDismissableClickArea.removeAttribute('disabled');
      if (this.sidebarForm) {
        removeEvent(this.sidebarForm, 'keyup', this.enableAction.bind(this));
        removeEvent(this.sidebarForm, 'change', this.enableAction.bind(this));
      }
    }
  }

  /**
   * Adds the disabled attribute
   * to the sidebar action
   * @return undefined
   */
  disableAction() {
    if (this.applyDismissableClickArea) {
      this.applyDismissableClickArea.setAttribute('disabled', true);
      if (this.sidebarForm) {
        addEvent(this.sidebarForm, 'keyup', this.enableAction.bind(this));
        addEvent(this.sidebarForm, 'change', this.enableAction.bind(this));
      }
    }
  }

  /**
   * Opens the dismissable sidebar panel, applies classes
   * @param  {event} event click event
   * @return undefined
   */
  open(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!this.isOpen) {
      if (this.openClickArea || this.remoteOpenClickArea) {
        removeClasses(this.dismissableSidebarPanels, [ 'is-compact' ]);
        removeEvent(this.openClickArea, 'click', this.open.bind(this));
        removeEvent(this.remoteOpenClickArea, 'click', this.open.bind(this));
      }
      this.isOpen = true;
    }
  }

  /**
   * Closes the dismissable sidebar panel, switches the functionality
   * of the dismissable sidebar panel to now open
   * @param  {event} event click event
   * @return undefined
   */
  close(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (this.isOpen) {
      if (this.closeClickArea) {
        addClasses(this.dismissableSidebarPanels, [ 'is-compact' ]);
        removeEvent(this.closeClickArea, 'click', this.close.bind(this));
      }
      this.isOpen = false;
      if (this.openClickArea || this.remoteOpenClickArea) {
        addEvent(this.openClickArea, 'click', this.open.bind(this));
        addEvent(this.remoteOpenClickArea, 'click', this.open.bind(this));
      }
    }
  }

  /**
   * Toggles content button if present
   * to switch between icon classes
   * @param  {event} event click event
   * @return undefined
   */
  apply(event) {
    if (this.applyDismissableClickArea) {
      const remoteIcon = this.dismissableSidebarPanels.querySelector('.js-dismissable-sidebar-panel__state');
      if (remoteIcon) {
        removeClasses(remoteIcon, [ 'icon-cme-filter' ]);
        addClasses(remoteIcon, [ 'fa', 'fa-check' ]);
      }
      this.close(event);
      removeEvent(this.closeClickArea, 'click', this.close.bind(this));
      triggerEvent(this.dismissableSidebarPanels, 'apply.commonui.dismissable-side-panel');
    }
  }

  destroy() {
    this.close();
  }

  /* eslint-disable no-console */
  isEverythingOk() {
    if (!this.dismissableSidebarPanels) {
      console.warn('CommonUI - Dismissable Sidebar Panel - There\'s no dismissable sidebar panel found');
      return false;
    }
    return true;
  }
  /* eslint-enable no-console */
}

/**
 * Creates a new dismissable sidebar panel instance
 * @param  {Object} config
 */
export default function initDismissableSidebarPanel(config = {}) {
  const {
    selector = '.js-dismissable-sidebar-panel',
    openSelector = '.js-dismissable-sidebar-panel__open',
    remoteOpenClickArea = '.js-dismissable-sidebar-panel__remote-open',
    closeSelector = '.js-dismissable-sidebar-panel__close',
    applyDismissableSidebarPanelSelector = '.js-dismissable-sidebar-panel__action',
    width = '25%',
  } = config;
  let dismissableSidebarPanels = null;
  if (typeof selector === 'string') {
    for (const dismissableSidebarPanel of document.querySelectorAll(selector)) {
      dismissableSidebarPanels = new DismissableSidebarPanel({
        dismissableSidebarPanel,
        openSelector,
        remoteOpenClickArea,
        closeSelector,
        applyDismissableSidebarPanelSelector,
        width,
      });
    }
  }
  return dismissableSidebarPanels;
}



// WEBPACK FOOTER //
// ./js/components/DismissableSidebarPanels.js